<footer class="footer">
  <div class="footer-links">
    <a [routerLink]="'home'">Home</a>
    <a [routerLink]="'help'">Help</a>
    <a [routerLink]="'terms'">Terms</a>
    <a [routerLink]="'contact-us'">Contact</a>
  </div>
</footer>
